/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';

/**
 * 
 * @export
 * @interface PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
 */
export interface PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest {
    /**
     * 検索キーワードのリスト
     * @type {Array<string>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    searchKeywords: Array<string>;
    /**
     * 配信方法のリスト
     * @type {Array<string>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    deliveryMethods: Array<PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestDeliveryMethodsEnum>;
    /**
     * メディア種類の子カテゴリIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    mediaTypeIds: Array<number>;
    /**
     * 業種の親カテゴリのIDリスト。業種の子カテゴリは今の所メディアとの紐付けができるほど良い分類ができていないため業種については指定できるのは親カテゴリのみになる。
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    mediaIndustryGroupIds: Array<number>;
    /**
     * エリア（全国や東北、関東など）のidのリスト。今のところは全国が選択された時のみ使われるが他のエリアについても追加予定。
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    areaIds: Array<number>;
    /**
     * エリアの都道府県のIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    prefectureIds: Array<number>;
    /**
     * 発行部数/PVのリスト
     * @type {Array<MediaReach>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    reaches: Array<MediaReach>;
    /**
     * 機関誌かどうか
     * @type {boolean}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    isIncludeSpecialPublications: boolean;
    /**
     * 選択済みリストのメディアのIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest
     */
    selectedMediaOutletIds: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestDeliveryMethodsEnum {
    Email = 'email',
    Fax = 'fax'
}

export function PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestFromJSON(json: any): PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest {
    return PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchKeywords': json['search_keywords'],
        'deliveryMethods': json['delivery_methods'],
        'mediaTypeIds': json['media_type_ids'],
        'mediaIndustryGroupIds': json['media_industry_group_ids'],
        'areaIds': json['area_ids'],
        'prefectureIds': json['prefecture_ids'],
        'reaches': ((json['reaches'] as Array<any>).map(MediaReachFromJSON)),
        'isIncludeSpecialPublications': json['is_include_special_publications'],
        'selectedMediaOutletIds': json['selected_media_outlet_ids'],
    };
}

export function PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestToJSON(value?: PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'search_keywords': value.searchKeywords,
        'delivery_methods': value.deliveryMethods,
        'media_type_ids': value.mediaTypeIds,
        'media_industry_group_ids': value.mediaIndustryGroupIds,
        'area_ids': value.areaIds,
        'prefecture_ids': value.prefectureIds,
        'reaches': ((value.reaches as Array<any>).map(MediaReachToJSON)),
        'is_include_special_publications': value.isIncludeSpecialPublications,
        'selected_media_outlet_ids': value.selectedMediaOutletIds,
    };
}

